<template>
  <div class="login-container d-flex align-center justify-center">
    <Snackbar :SnackbarComponent="SnackbarComponent" />
    <v-container class="login-box elevation-6">
      <v-row>
        <v-col
          v-if="$vuetify.display.mdAndUp"
          cols="12"
          md="6"
          class="left-section d-flex flex-column justify-center align-center"
        >
          <div class="white--text text-h5">Hello</div>
          <h1 class="white--text text-h4 font-weight-bold">Welcome to</h1>

          <div class="mt-7">
            <div
              class="rounded-image-container d-flex justify-center align-center"
            >
              <v-img
                :src="require('@/assets/DyrectoriImg.png')"
                height="50"
                width="100"
                contain
              />
            </div>
          </div>

          <h1 class="white--text text-h4 font-weight-bold">dyrectori</h1>
          <p class="FontSize12px">shared entry books</p>
        </v-col>

        <v-col cols="12" md="6" :class="$vuetify.display.mdAndUp ? 'pa-3' : ''">
          <v-card class="pa-6 rounded-lg elevation-4" min-height="320px">
            <div v-if="!$vuetify.display.mdAndUp">
              <div class="d-flex align-left">
                <!-- Image -->
                <v-img
                  :src="require('@/assets/DyrectoriImg.png')"
                  height="50"
                  width="100"
                  contain
                  class="mr-n10"
                />

                <!-- Text -->
                <div class="mr-8 mt-1">
                  <h5 class="white--text text-h5 font-weight-bold mb-1">
                    dyrectori
                  </h5>
                  <p class="FontSize12px mb-0 mt-n3">shared entry books</p>
                </div>
              </div>
            </div>

            <v-container>
              <h2 class="text-center text-h5 font-weight-bold">
                {{ NameValid == true ? "Sign Up" : "Login" }}
              </h2>

              <v-form ref="loginForm" class="mt-4">
                <v-text-field
                  v-if="!IsOTPEnabled && NameValid == true"
                  v-model="Login.name"
                  label="Name *"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-account-circle"
                  :rules="[rules.required]"
                />

                <v-text-field
                  v-if="!IsOTPEnabled"
                  v-model="Login.email_id"
                  label="Email ID *"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-email"
                  :rules="[rules.required, rules.email]"
                  :readonly="IsOTPEnabled || NameValid == true"
                  @keydown.enter.prevent="validateMethod()"
                />

                <div v-if="IsOTPEnabled" class="mt-4 font-weight-bold">
                  Enter OTP *
                </div>
                <v-otp-input
                  v-if="IsOTPEnabled"
                  density="compact"
                  v-model="Login.otp"
                  @keydown.enter.prevent="validateMethod()"
                />
                <v-btn
                  v-if="NameValid == false"
                  :loading="loginLoader"
                  block
                  color="red darken-2"
                  class="mt-4"
                  @click="validateMethod"
                >
                  {{ IsOTPEnabled ? "Verify OTP" : "Login" }}
                </v-btn>

                <v-btn
                  v-if="NameValid == true"
                  :loading="signUpLoader"
                  block
                  color="red darken-2"
                  class="mt-4"
                  @click="validateSignUp"
                >
                  Sign Up
                </v-btn>

                <v-row class="mt-3">
                  <v-col
                    cols="12"
                    class="d-flex align-center justify-space-between"
                  >
                    <v-btn
                      v-if="IsOTPEnabled"
                      text
                      size="small"
                      @click="IsOTPEnabled = false"
                    >
                      <span class="text-red">Change Email</span>
                    </v-btn>

                    <div
                      v-if="ResendOTPValue && IsOTPEnabled"
                      class="text-caption font-weight-bold"
                    >
                      Resend OTP in {{ countdown }}s
                    </div>

                    <v-btn
                      v-if="showResendButton"
                      text
                      class="text-blue"
                      @click="resendOTP"
                    >
                      Resend OTP
                    </v-btn>
                  </v-col>

                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn
                      size="small"
                      class="mt-3 text-capitalize"
                      @click="openDyrectori()"
                      rounded
                    >
                      <v-icon color="black" size="x-large" class="mr-2"
                        >mdi-undo-variant</v-icon
                      >
                      Back
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { useDisplay } from "vuetify";
import { signUp, signIn, confirmSignIn, signOut } from "aws-amplify/auth";
import Snackbar from "@/components/Extras/Snackbar.vue";
export default {
  components: { Snackbar },
  data: () => ({
    cardHeight: 0,
    Login: {
      email_id: "",
      name: "",
      otp: "",
    },
    SnackbarComponent: {},
    IsOTPFieldEnabled: false,
    loginLoader: false,
    signUpLoader: false,
    IsOTPEnabled: false,
    NameValid: false,
    countdown: 30,
    timer: null,
    ResendOTPValue: false,
    showResendButton: false,
    SignUpOTP: "",
    ISSignUpBoolean: false,
    rules: {
      required: (v) => !!v || "",
      email: (v) => /.+@.+\..+/.test(v) || "Enter a valid email",
    },
  }),
  beforeUnmount() {
    clearInterval(this.timer);
  },
  mounted() {
    const display = useDisplay();
    this.cardHeight = display.height._object.height;
  },
  methods: {
    async validateMethod() {
      const { valid } = await this.$refs.loginForm.validate();
      if (valid) {
        this.signInMethod(this.IsOTPEnabled ? "VERIFY_OTP" : "SEND_OTP");
      } else if (this.Login.email_id == "" && this.IsOTPEnabled == false) {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          timeout: 2000,
          SnackbarText: `Please fill mandatory fields`,
        };
      } else if (this.Login.otp == "" && this.IsOTPEnabled) {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          timeout: 2000,
          SnackbarText: `Enter OTP`,
        };
      }
    },

    async validateSignUp() {
      const { valid } = await this.$refs.loginForm.validate();
      if (valid) {
        this.signUpMethod();
      } else if (this.Login.email_id == "" || this.Login.name == "") {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          timeout: 2000,
          SnackbarText: `Please fill mandatory fields`,
        };
      }
    },
    async signInMethod(action) {
      console.log("iiiiiisss", this.IsOTPEnabled);
      switch (action) {
        case "SEND_OTP":
          try {
            this.loginLoader = true;
            this.user = await signIn({
              username: this.Login.email_id.toLocaleLowerCase(),
              options: {
                authFlowType: "CUSTOM_WITHOUT_SRP",
              },
            });
            if (
              this.user.nextStep.signInStep ==
              "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
            ) {
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "green",
                timeout: 2000,
                SnackbarText: `Verification OTP sent to ${this.Login.email_id.toLocaleLowerCase()}`,
              };

              this.counter = 60;

              setTimeout(() => {
                this.IsOTPEnabled = true;
                this.loginLoader = false;

                this.startCountdown();
              }, 1000);

              this.$forceUpdate();
            }
          } catch (error) {
            this.loginLoader = false;
            console.log("erro", error.message);
            if (error.message == "There is already a signed in user.") {
              this.loginLoader = true;
              await signOut({ global: true });
              this.signInMethod("SEND_OTP");
            } else if (
              error.message ==
                "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup." ||
              error.message ==
                "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED: Kindly Signup."
            ) {
              // await signOut({ global: true });
              this.NameValid = true;
              // this.signUpMethod();
            } else {
              this.loginLoader = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "redColorVariant3",
                timeout: 2000,
                SnackbarText: error.message,
              };
            }
          }
          break;
        case "VERIFY_OTP":
          try {
            this.loginLoader = true;
            console.log("coming In");
            await confirmSignIn({ challengeResponse: this.Login.otp })
              .then((res) => {
                console.log("res", res);
                this.SnackbarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "green",
                  SnackbarText: "Login Successfull",
                };
                console.log("yes");
                this.IsOTPFieldEnabled = false;
                this.IsSessionLoggedOut = false;
                localStorage.setItem("IsLoggedOut", "false");
                this.loginLoader = false;
                this.ActivateMethod();
              })
              .catch((err) => {
                if (err) {
                  this.counter = 0;
                  this.Login.otp = "";
                }
                this.SnackbarComponent.SnackbarVmodel = false;
                this.SnackbarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "red",
                  SnackbarText: err.message,
                };
                this.OTPErrorMessage = err.message;
                this.loginLoader = false;
              });
          } catch (error) {
            console.log("err", error);
          }
          break;
        case "RESEND_OTP":
          try {
            this.user = await signIn({
              username: this.Login.email_id.toLocaleLowerCase(),
              options: {
                authFlowType: "CUSTOM_WITHOUT_SRP",
              },
            });
            if (
              this.user.nextStep.signInStep ==
              "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
            ) {
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "green",
                timeout: 2000,
                SnackbarText: `Verification OTP sent to ${this.Login.email_id.toLocaleLowerCase()}`,
              };

              this.counter = 60;

              setTimeout(() => {
                this.IsOTPEnabled = true;
                this.loginLoader = false;
              }, 1000);
              this.startCountdown();

              this.$forceUpdate();
            }
          } catch (error) {
            console.log("erro", error);
            if (error.message == "There is already a signed in user.") {
              this.loginLoader = true;
              await signOut({ global: true });
              this.signInMethod("SEND_OTP");
            } else {
              this.loginLoader = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "redColorVariant3",
                timeout: 2000,
                SnackbarText: error.message,
              };
            }
          }
          break;
      }
    },
    async signUpMethod() {
      try {
        this.signUpLoader = true;
        let signUp_result = await signUp({
          username: this.Login.email_id,
          password: "testPassword@123",
          options: {
            userAttributes: {
              name: this.Login.name,
              // user_email_id: this.Login.email_id,
            },
          },
        });
        console.log("signUp_result", signUp_result);
        if (signUp_result.nextStep.signUpStep == "DONE") {
          // this.IsOTPEnabled = true;
          this.NameValid = false;
          await this.signInMethod("SEND_OTP");
        }
        this.signUpLoader = false;
      } catch (error) {
        this.signUpLoader = false;
        this.SnackbarComponent = {
          snackbarVmodel: true,
          snackbarColor: "redColorVariant2",
          snackbarMessage: error.message,
        };
      }
    },

    ActivateMethod() {
      this.$store.commit("SET_USER_MAIL", this.Login.email_id);
      setTimeout(() => {
        this.$router.push("/LandingPage");
      }, 1000);
    },
    openDyrectori() {
      window.location.href = "https://dyrectori.com";
    },
    startCountdown() {
      this.ResendOTPValue = true;
      this.showResendButton = false;
      this.countdown = 45;

      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.ResendOTPValue = false;
          this.showResendButton = true;
        }
      }, 1000);
    },
    resendOTP() {
      this.signInMethod("RESEND_OTP");
    },
    backToHome() {
      window.location.href = "https://www.dyrectori.com";
    },
  },
};
</script>

<style>
.container {
  display: flex;
  height: 100vh;
}

.wave-container {
  width: 100%; /* Set wave container to 60% of the screen width */
  background: linear-gradient(135deg, #e91b00 0%, #ed9d87 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  overflow: hidden;
  /* background-image: url("@/assets/bg1.png"); */
}

.wave-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  clip-path: ellipse(50% 100% at 40% 50%); /* Adjusted for left alignment */
  z-index: 1;
}

.wave-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 20px;
}
.CardColor {
  background: linear-gradient(135deg, #e91b00 0%, #ed9d87 100%);
}
.containerColor {
  min-height: 100vh;
  background: linear-gradient(135deg, #e91b00 0%, #ed9d87 100%);
}
.CardStyless {
  background-color: #ffffff;
  border-radius: 0px 100px;
}
.ImgTransition {
  animation: zoomInOut 4s ease-in-out infinite;
}

@keyframes zoomInOut {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.login-container {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f1b6b6 0%, #e53b0c 100%);
  padding: 20px;
}
.login-box {
  max-width: 1000px;
  min-height: 350px;
  background: white;
  border-radius: 15px;
}
.left-section {
  background: linear-gradient(135deg, #f8260a, #e48c74);
  border-radius: 15px 0 0 15px;
  padding: 40px;
  color: white;
}
.right-section {
  display: flex;
  align-items: center;
  justify-content: center;
}
.rounded-image-container {
  width: 100px;
  height: 100px;
  border-radius: 50px;
  overflow: hidden;
  background-color: white;
}
</style>
